import React from 'react'
// import styles from "./layout.module.css";

export default function Layout1() {
    return (
        <>
        </ >
    )
}
